var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('Header'),_c('div',{staticClass:"App__navigationView"},[_c('NavMenu',{directives:[{name:"show",rawName:"v-show",value:(this.isShowedNavMenu),expression:"this.isShowedNavMenu"}]}),_vm._t("private-template")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }